import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4108563c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "flex-row bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center",
  style: {"height":"30px","margin-bottom":"5px"}
}
const _hoisted_4 = {
  class: "input-group align-self-center ms-auto bd-highlight mr-5",
  style: {"width":"20%"}
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "序号"),
    /*#__PURE__*/_createElementVNode("th", null, "模板名"),
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "门店"),
    /*#__PURE__*/_createElementVNode("th", null, "审批人"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1))
const _hoisted_8 = { id: "member-list" }
const _hoisted_9 = { class: "flex-row flex-align-center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "table table-borderless" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*模板名:")
  ])
], -1))
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*门店:")
  ])
], -1))
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*抄送:")
  ])
], -1))
const _hoisted_20 = { class: "mb-1 flex-row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*审批人:")
  ])
], -1))
const _hoisted_22 = { class: "mb-1 flex-row" }
const _hoisted_23 = { class: "ml-2 mr-2" }
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_CommonModal = _resolveComponent("CommonModal")!
  const _component_PickEmployee = _resolveComponent("PickEmployee")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openAddDialog && $setup.openAddDialog(...args)))
          }, "添加模板")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shop) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shops, (value, idx) => {
              return (_openBlock(), _createElementBlock("option", {
                key: idx,
                value: value.id
              }, _toDisplayString(value.name), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.shop]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tbody", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.title), 1),
                _createElementVNode("td", null, _toDisplayString(value.id), 1),
                _createElementVNode("td", null, _toDisplayString($setup.getShopName(value.shop)), 1),
                _createElementVNode("td", null, _toDisplayString($setup.getApproverNames(value)), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditDialog(value))
                    }, null, 8, _hoisted_10),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteOne(value.id, value.title))
                    }, null, 8, _hoisted_11)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadTagList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    (_ctx.showAddDialog)
      ? (_openBlock(), _createBlock(_component_CommonModal, {
          key: 0,
          onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAddDialog=false)),
          onConfirm: $setup.editEmployee
        }, {
          default: _withCtx(() => [
            _createElementVNode("table", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editing.title) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.editing.title]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_16,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editing.shop) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shops, (value, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: idx,
                          value: value.id
                        }, _toDisplayString(value.name), 9, _hoisted_18))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.editing.shop]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_19,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_20, [
                    (_ctx.editing.chaosong)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "approver",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editing.chaosong = undefined))
                        }, _toDisplayString(_ctx.editing.chaosong?.name) + "(" + _toDisplayString(_ctx.editing.chaosong?.dept) + ")", 1))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.showPickEmployee=true;_ctx.pickerType=1}),
                          class: "approver ml-2"
                        }, "+"))
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_21,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editing.approver, (value, idx) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", {
                          class: "approver",
                          onClick: ($event: any) => (_ctx.editing.approver.splice(idx,1))
                        }, _toDisplayString(value.name) + "(" + _toDisplayString(value.dept) + ")", 9, _hoisted_24)
                      ]))
                    }), 256)),
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.showPickEmployee=true;_ctx.pickerType=0}),
                      class: "approver ml-2"
                    }, "+")
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showPickEmployee)
      ? (_openBlock(), _createBlock(_component_PickEmployee, {
          key: 1,
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showPickEmployee=false)),
          onConfirm: $setup.addApprover,
          shop: _ctx.editing.shop
        }, null, 8, ["onConfirm", "shop"]))
      : _createCommentVNode("", true),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}